<template lang="pug">
  .collection-carousel
    io-lazy-load
      .carousel__nav
        icon-button(
          v-if="$mq !== 'mobile'"
          class="carousel__nav__prev"
          label="Previous Slide"
          icon="chevron-left-big"
          size="64px"
          @click="slidePrev"
        )
        icon-button(
          v-if="$mq !== 'mobile'"
          class="carousel__nav__next"
          label="Next Slide"
          icon="chevron-left-big"
          size="64px"
          @click="slideNext"
        )
      .featured-collection__slider
        carousel(
          ref="carousel"
          :infinite="true"
          :slides-to-show="['mobile', 'tablet'].includes($mq) ? 2 : 3"
          :center-mode="true"
        )
          slot
</template>

<script>
import IoLazyLoad from 'scripts/components/basic/IoLazyLoad.vue'
import IconButton from 'scripts/components/buttons/IconButton.vue'
import Carousel from 'scripts/components/basic/Carousel.vue'

export default {
  name: 'CollectionCarousel',
  components: {
    Carousel,
    IconButton,
    IoLazyLoad,
  },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
  },
}
</script>

<style scoped lang="scss">
  .collection-carousel {

    .carousel__nav__prev {
      transition: opacity 0.3s ease-out;
    }

    .carousel__nav__next {
      transform: scaleX(-1) translateY(-50%);
    }
  }
</style>
